import React, { Component } from "react";
import SideBar from "../common/sideBar";
import UserProfile from "../common/userProfile";
import ScrollTop from "../common/scrollTop";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import HelmetComponent from "../common/helmetComponent";
import { toast } from "react-toastify";
import AlertError from "../common/alertError";
import AlertSuccess from "../common/alertSuccess";
import {
  getBlogCategory,
  loadAllBlogcategory,
  deletedBlogcategory,
  updateBlogcategory,
} from "../../store/blogCategory";
import AddBlogCategory from "./addBlogcategory";
import {
  informationSaved,
  deleted,
  activated,
  deactivated,
  failed,
} from "../common/misc";
import BlogCategoryGrid from "./blogCategorygrid";
import SortingIconUp from "../common/sortingIconUp";
import SortingIcon from "../common/sortingIcon";

class BlogCategory extends Component {
  state = {
    userShow: false,
    modal: false,
    active: false,
    id: "",
    admin_id: "",
    status: "",
    msg: "",
    data: "",
    editShow: false,
    delete_id: "",
    asside: false,
    isShow: false,
    asside2: false,
    asside3: false,
    sort_by: "category",
    sort: "desc",
  };
  toggleAddUser = () => {
    this.setState({
      isShow: !this.state.isShow,
    });
  };
  toggleAsside = () => {
    this.setState({
      asside2: false,
      asside: !this.state.asside,
      asside3: false,
    });
  };
  toggleAsside2 = () => {
    this.setState({
      asside: false,
      asside2: !this.state.asside2,
      asside3: false,
    });
  };
  toggleAsside3 = () => {
    this.setState({
      asside2: false,
      asside3: !this.state.asside3,
      asside: false,
    });
  };
  toggleShowUser = () => {
    this.setState({
      userShow: !this.state.userShow,
    });
  };

  toggleEditUser = (data, id) => {
    this.setState({
      editShow: !this.state.editShow,
      data: data,
      id: id,
    });
  };
  toggle = (id) => {
    this.setState({
      modal: !this.state.modal,
      delete_id: id,
    });
  };

  deletedBlogcategory = (id) => {
    this.props.deletedBlogcategory(id, this.callback);
  };
  callback = (res) => {
    if (res && res.status === 200) {
      this.props.loadAllBlogcategory();
      this.setState({
        modal: !this.state.modal,
      });
      toast(<AlertSuccess message={deleted} />);
    } else {
      toast(<AlertError message={failed} />);
    }
  };
  componentDidMount = () => {
    this.props.loadAllBlogcategory();
  };

  // sortByName = () => {
  //   if (this.state.sort === "desc")
  //     this.setState({
  //       sort_by: "name",
  //       sort: "asc",
  //     });
  //   else {
  //     this.setState({
  //       sort_by: "name",
  //       sort: "desc",
  //     });
  //   }
  // };

  // componentDidUpdate = (prevProps, prevState) => {
  //   if (
  //     this.state.sort_by !== prevState.sort_by ||
  //     this.state.sort !== prevState.sort
  //   ) {
  //     this.props.loadAllBlogcategory({
  //       sort_by: this.state.sort_by,
  //       sort: this.state.sort,
  //     });
  //   }
  // };

  render() {
    const { blogcategory } = this.props;
    return (
      <div
        className={
          this.state.asside === true ||
          this.state.asside2 === true ||
          this.state.asside3 === true
            ? "header-mobile-fixed subheader-enabled aside-enabled aside-fixed aside-secondary-enabled"
            : "header-mobile-fixed subheader-enabled aside-enabled aside-fixed aside-secondary-enabled  aside-minimize"
        }
      >
        <div className="d-flex flex-column flex-root">
          <HelmetComponent title="Blog Category Management" />
          <div className="d-flex flex-row flex-column-fluid page">
            <SideBar
              toggleAsside={this.toggleAsside}
              toggleAsside3={this.toggleAsside3}
              userShow={this.state.userShow}
              toggleShowUser={this.toggleShowUser}
              asside={this.state.asside}
              asside3={this.state.asside3}
              asside2={this.state.asside2}
              toggleAsside2={this.toggleAsside2}
            />
            <div
              className="d-flex flex-column flex-row-fluid wrapper"
              id="kt_wrapper"
            >
              <div className="content d-flex flex-column flex-column-fluid">
                <div className="subheader py-2 py-lg-4 subheader-transparent">
                  <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div className="d-flex align-items-center flex-wrap mr-2">
                      <h5 className="text-dark font-weight-bold mt-2 mb-2 mr-5">
                        Blog Categories
                      </h5>
                      <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-5 bg-gray-200"></div>
                      <div className="d-flex align-items-center">
                        <span className="text-dark-50 font-weight-bold">
                          Total : {blogcategory.length} records
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <a
                        href="javascript:void (0)"
                        className="btn btn-light-primary font-weight-bold btn-sm px-4 font-size-base ml-2"
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleAddUser();
                        }}
                        data-toggle="tooltip"
                        data-placement="right"
                        data-container="body"
                        data-boundary="window"
                      >
                        Add Blog Category
                      </a>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column-fluid">
                  <div className="container-fluid">
                    <div className="card card-custom">
                      <div className="card-header flex-wrap border-0 pt-6 pb-0">
                        <div className="card-title">
                          <h3 className="card-label">
                            Blog Category Management
                            <span className="d-block text-muted pt-2 font-size-sm">
                              You can view/add/edit/delete blog categories.
                            </span>
                          </h3>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded">
                          <table
                            className="datatable-table"
                            style={{ display: "block" }}
                          >
                            <thead className="datatable-head">
                              <tr
                                className="datatable-row"
                                style={{ left: "0px" }}
                              >
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "200px" }}>
                                    Category Name
                                    {/* {this.state.sort_by === "name" &&
                                    this.state.sort === "asc" ? (
                                      <SortingIcon sorting={this.sortByName} />
                                    ) : (
                                      <SortingIconUp
                                        sorting={this.sortByName}
                                      />
                                    )} */}
                                  </span>
                                </th>
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "200px" }}>
                                    Created On
                                  </span>
                                </th>

                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "200px" }}>Action</span>
                                </th>
                              </tr>
                            </thead>
                            <BlogCategoryGrid
                              data={this.state.data}
                              isShow={this.state.editShow}
                              toggleEditUser={this.toggleEditUser}
                              delete_id={this.state.delete_id}
                              modal={this.state.modal}
                              toggle={this.toggle}
                              id={this.state.id}
                              blogCategory={blogcategory}
                              deleted={this.deletedBlogcategory}
                            />
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <UserProfile
            userShow={this.state.userShow}
            toggleShowUser={this.toggleShowUser}
          />
          <AddBlogCategory
            isShow={this.state.isShow}
            toggleAddUser={this.toggleAddUser}
          />
          <ScrollTop />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  blogcategory: getBlogCategory(state).blogcategory,
});
const mapDispatchToProps = (dispatch) => ({
  loadAllBlogcategory: (param) => dispatch(loadAllBlogcategory(param)),
  deletedBlogcategory: (id, callback) =>
    dispatch(deletedBlogcategory(id, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BlogCategory);
